<template>
  <div class="row justify-content-center">
    <div class="col-12" v-if="!loading">
      <h3 v-if="onBoarding.substep != 0" class="card-title text-dark">
        <!-- <strong>{{ $t("lang.onBoarding.describe_your_services") }}</strong> -->
      </h3>
      <!-- Video -->
      <div class="col-12" v-if="onBoarding.substep == 0 && !hasPermissions('adminClients')">
        <h3 class="card-title text-primary">
          {{ $t("lang.onBoarding.first_order") }}
        </h3>
        <h6>{{ $t("lang.onBoarding.how_does_it_works") }}</h6>
        <div class="col-10 offset-1 d-flex justify-content-center embed-responsive embed-responsive-21by9 mt-4 mb-3">
          <iframe :src="getVideo"
            allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;" width="100%"
            height="600px" style="border: none; border-radius: 24px"></iframe>
        </div>
        <div class="text-center mt-4">
          <button class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-primary
            mx-1
            px-4
          " type="button" @click="start()">
            {{ $t("lang.button.start") }}
          </button>
        </div>
      </div>
      <!--End Video -->

      <!-- Notice of process initiation. -->
      <div class="col-12 d-flex justify-content-center mt-5" v-if="onBoarding.substep == 1 && onBoarding.startProcess">
        <div class="col-12 col-md-6 col-lg-4 text-center">
          <p>
            {{
              $t(
                "lang.onBoarding.step1_1_hint",
                this.$store.state.onboarding.lang
              )
            }}
          </p>
          <h5 class="mt-5">
            {{
              $t(
                "lang.onBoarding.pre_questions1",
                this.$store.state.onboarding.lang
              )
            }}
          </h5>

          <h5 class="mt-5">
            {{
              $t(
                "lang.onBoarding.pre_questions2",
                this.$store.state.onboarding.lang
              )
            }}
          </h5>
        </div>
      </div>

      <!-- Step 1 Name company -->
      <div v-if="onBoarding.substep == 1 && !onBoarding.startProcess">
        <div class="card-body text-center">
          <p>
            ( 1 / 6 )
          </p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_1')" />
          <h4 class="mt-5">
            {{
              $t(
                "lang.onBoarding.step1_1_question",
                this.$store.state.onboarding.lang
              )
            }}
            <i class="ml-1 text-danger">*</i>
          </h4>
          <div class="row justify-content-center mt-4">
            <div class="col-8 col-sm-7 col-md-4">
              <input class="w-100 d-inline  text-center text-primary  mb-1 lead pl-2 border-style-dashed" :placeholder="$t(
                    'lang.onBoarding.example',
                    this.$store.state.onboarding.lang
                  ) + ': Oliverlist'
                  " maxlength="60" type="text" :value="onBoarding.productName" @input="changeProductName" />
              <span class="col-12 text-center mt-2">
                {{
                  $t(
                    "lang.label.charactersavailable",
                    this.$store.state.onboarding.lang,
                    { actual: onBoarding.productName.length, total: 60 }
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2 link to the company's website -->
      <div v-if="onBoarding.substep == 2">
        <div class="card-body text-center">
          <p>
            ( 2 / 6 )
          </p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_2')" />
          <h4 class="my-5">
            {{
              $t(
                "lang.onBoarding.step1_2_new_question",
                this.$store.state.onboarding.lang
              )
            }}
            <i class="ml-0 text-danger">*</i>
          </h4>
          <div class="row justify-content-center">
            <div class="col-12 col-md-6">
              <input class="w-100 d-inline  text-center text-primary  mb-1 lead pl-2 border-style-dashed" :placeholder="$t(
                    'lang.onBoarding.example',
                    this.$store.state.onboarding.lang
                  ) + ': http://www.oliverlist.com'
                  " maxlength="150" type="text" :value="onBoarding.website" @input="changeWebsite" />
              <span class="text-muted" v-if="onBoarding.website && onBoarding.disablednext">
                {{
                  $t(
                    "lang.ondemand.urlerror",
                    this.$store.state.onboarding.lang
                  )
                }}
                Example: https://www.oliverlist.com
              </span>
              <span class="col-12 text-center mt-2">
                {{
                  $t(
                    "lang.label.charactersavailable",
                    this.$store.state.onboarding.lang,
                    { actual: onBoarding.website.length, total: 150 }
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3 Offer to prospects -->
      <div v-if="onBoarding.substep == 3">
        <div class="card-body text-center">
          <p>
            ( 3 / 6 )
          </p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_3')" />
          <h4 class="my-5">
            {{
              $t(
                "lang.onBoarding.step1_3_question",
                this.$store.state.onboarding.lang
              )
            }}
            <i class="ml-1 text-danger">*</i>
          </h4>
          <div class="row justify-content-center">
            <div class="col-md-4 mt-2">
              <select v-model="onBoarding.offer_prospect" class="d-inline form-control" style="font-size: 18px"
                @change="changeOfferProspect">
                <option v-for="offer in select_offer_prospect" :key="offer.id" :value="offer.id" class="optionSelect">
                  {{ offer.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 4 Description Sell -->
      <div v-if="onBoarding.substep == 4">
        <div class="card-body text-center justify-content-center">
          <p>( 4 / 6 )</p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_4')" />

          <Example :classCustom="'col-8 offset-md-2'" :message="$t(
            'lang.onBoarding.step1_4_example',
            this.$store.state.onboarding.lang
          )
            " :question="$t('lang.onBoarding.and_you', this.$store.state.onboarding.lang) +
    '<i class=\'ml-1 text-danger\'>*</i>'
    " />
          <div class="col-8 offset-md-2 mt-4 px-0">
            <div class="input-group mt-2 justify-content-start">
              <span class="d-flex align-items-end lead text-dark pt-0 pl-3 font-weight-bold  pl-0 bg-white text-size-20">
                {{
                  $t(
                    "lang.onBoarding.description_sell_prepend",
                    this.$store.state.onboarding.lang
                  ).replace("[]", this.$store.state.onboarding.productName)
                }},
              </span>
              <input class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-2 border-style-dashed text-size-20"
                maxlength="150" ref="inputOne" type="text" :value="onBoarding.descriptionSell"
                @input="changeDescriptionSell" :placeholder="$t(
                  'lang.onBoarding.step1_4_1_example',
                  this.$store.state.onboarding.lang
                )
                  " />
              <span class="col-12 text-center mt-2">
                {{
                  $t(
                    "lang.label.charactersavailable",
                    this.$store.state.onboarding.lang,
                    { actual: onBoarding.descriptionSell.length, total: 150 }
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Step 5  -->
      <div v-if="onBoarding.substep == 5">
        <div class="card-body text-center">
          <p>
            ( 5 / 6 )
          </p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_6')" />

          <Example :classCustom="'col-8 offset-md-2'" :message="$t(
            'lang.onBoarding.step1_6_example',
            this.$store.state.onboarding.lang
          ) + ':'
            " :items="[
    $t(
      'lang.onBoarding.step1_6_item_example1',
      this.$store.state.onboarding.lang
    ),
    $t(
      'lang.onBoarding.step1_6_item_example2',
      this.$store.state.onboarding.lang
    ),
    $t(
      'lang.onBoarding.step1_6_item_example3',
      this.$store.state.onboarding.lang
    )
  ]" :question="$t('lang.onBoarding.and_you', this.$store.state.onboarding.lang) +
  '<i class=\'ml-1 text-danger\'>*</i>'
  " />
          <div class="col-8 offset-md-2 mt-5">
            <p class="h5 mt-4 text-size-20 text-left ">
              {{
                $t(
                  "lang.onBoarding.step1_6_question",
                  this.$store.state.onboarding.lang
                ).replace("[]", this.$store.state.onboarding.productName)
              }}
            </p>
          </div>
          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">1. </span>
                  <input @focus="showMessage(5, 'enable', 0)" @blur="showMessage(5, 'disable', 0)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 5)
                          .answers[0].text
                        " @input="changeQuestions($event, 5, 1)" :placeholder="$t(
      'lang.onBoarding.step1_6_item_example1',
      this.$store.state.onboarding.lang
    )
      " />
                </div>
                <p v-show="showInputMessage(5, 0)" class="text-left ml-4">
                  {{ characterResponseCounter(5, 1, 150) }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">2. </span>
                  <input @focus="showMessage(5, 'enable', 1)" @blur="showMessage(5, 'disable', 1)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 5)
                      .answers[1].text
                      " @input="changeQuestions($event, 5, 2)" :placeholder="$t(
    'lang.onBoarding.step1_6_item_example2',
    this.$store.state.onboarding.lang
  )
    " />
                </div>
                <p v-show="showInputMessage(5, 1)" class="text-left ml-4">
                  {{ characterResponseCounter(5, 2, 150) }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">3. </span>
                  <input @focus="showMessage(5, 'enable', 2)" @blur="showMessage(5, 'disable', 2)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 5)
                      .answers[2].text
                      " @input="changeQuestions($event, 5, 3)" :placeholder="$t(
    'lang.onBoarding.step1_6_item_example3',
    this.$store.state.onboarding.lang
  )
    " />
                </div>
                <p v-show="showInputMessage(5, 2)" class="text-left ml-4">
                  {{ characterResponseCounter(5, 3, 150) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 6 -->
      <div v-if="onBoarding.substep == 6">
        <div class="card-body text-center">
          <p>
            ( 6 / 6 )
          </p>
          <Tips :classCustom="'col-8 offset-md-2'" :message="$t('lang.onBoarding.tip_7')" />

          <Example :classCustom="'col-8 offset-md-2'" :textHtml="$t(
            'lang.onBoarding.step1_7_example',
            this.$store.state.onboarding.lang
          ).replace(
            'Oliverlist',
            '<span class=\'text-primary\'>Oliverlist</span>'
          ) + ':'
            " :items="[
    $t(
      'lang.onBoarding.step1_7_item_example1',
      this.$store.state.onboarding.lang
    ),
    $t(
      'lang.onBoarding.step1_7_item_example2',
      this.$store.state.onboarding.lang
    ),
    $t(
      'lang.onBoarding.step1_7_item_example3',
      this.$store.state.onboarding.lang
    )
  ]" :question="$t('lang.onBoarding.and_you', this.$store.state.onboarding.lang) +
  '<i class=\'ml-1 text-danger\'>*</i>'
  " />
          <div class="col-8 offset-md-2 mt-5">
            <p class="h5 mt-4 text-size-20 text-left">
              {{
                $t(
                  "lang.onBoarding.step1_7_question",
                  this.$store.state.onboarding.lang
                ).replace("[]", this.$store.state.onboarding.productName)
              }}
            </p>
          </div>
          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">1. </span>
                  <input @focus="showMessage(6, 'enable', 0)" @blur="showMessage(6, 'disable', 0)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 6)
                          .answers[0].text
                        " @input="changeQuestions($event, 6, 1)" :placeholder="$t(
      'lang.onBoarding.step1_7_item_example1',
      this.$store.state.onboarding.lang
    )
      " />
                </div>
                <p v-show="showInputMessage(6, 0)" class="text-left ml-4">
                  {{ characterResponseCounter(6, 1, 150) }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">2. </span>
                  <input @focus="showMessage(6, 'enable', 1)" @blur="showMessage(6, 'disable', 1)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 6)
                      .answers[1].text
                      " @input="changeQuestions($event, 6, 2)" :placeholder="$t(
    'lang.onBoarding.step1_7_item_example2',
    this.$store.state.onboarding.lang
  )
    " />
                </div>
                <p v-show="showInputMessage(6, 1)" class="text-left ml-4">
                  {{ characterResponseCounter(6, 2, 150) }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-8 offset-md-2 d-flex justify-content-start mt-3">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 d-flex justify-content-start px-0">
                  <span class="d-flex align-items-end">3. </span>
                  <input @focus="showMessage(6, 'enable', 2)" @blur="showMessage(6, 'disable', 2)"
                    class="w-50 text-primary flex-fill mt-2  mx-2 mb-1 lead pl-0 border-style-dashed text-size-20"
                    maxlength="150" type="text" :value="onBoarding.questions.data.find(e => e.question === 6)
                      .answers[2].text
                      " @input="changeQuestions($event, 6, 3)" :placeholder="$t(
    'lang.onBoarding.step1_7_item_example3',
    this.$store.state.onboarding.lang
  )
    " />
                </div>
                <p v-show="showInputMessage(6, 2)" class="text-left ml-4">
                  {{ characterResponseCounter(6, 3, 150) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="onBoarding.substep == 13">
        <div class="card-body text-center">
          <h3 class="pt-2 pb-2 mt-5">
            {{
              $t("lang.onBoarding.excellent", this.$store.state.onboarding.lang)
            }}
          </h3>
          <h6 class="text-primary">
            {{
              $t(
                "lang.onBoarding.lets_move_on",
                this.$store.state.onboarding.lang
              )
            }}
          </h6>
        </div>
      </div>

      <div v-if="onBoarding.substep == 14" class="mt-4">
        <modal name="step15" :resizable="true" height="auto" width="90%">
          <div class="p-4 text-left">
            <h3 class="card-title text-primary mb-2">
              {{
                $t(
                  "lang.onBoarding.mails_modal_title",
                  this.$store.state.onboarding.lang
                )
              }}
            </h3>
            <p class="text-secondary mb-3">
              {{
                $t(
                  "lang.onBoarding.mails_modal_description",
                  this.$store.state.onboarding.lang
                )
              }}
            </p>

            <div class="row">
              <div class="col-md-5">
                <Step1Summary />
              </div>
              <div class="col-md-7">
                <MailsModal />
              </div>
            </div>
            <div class="row justify-content-center">
              <button class="
                btn btn-secondary
                large
                cursor-pointer
                font-weight-bolder
                mt-4
                mr-2
              " type="button" @click="closeModal(15)">
                {{ $t("lang.button.back") }}
              </button>
            </div>
          </div>
        </modal>
        <Step1Summary />
      </div>

      <div class="text-center" v-if="onBoarding.substep == 13">
        <a class="text-primary mt-5" type="button" @click="summary"><i class="icon-arrow-right"></i>
          {{
            $t(
              "lang.onBoarding.i_want_a_summary",
              this.$store.state.onboarding.lang
            )
          }}
        </a>
      </div>

      <div class="text-center" v-if="onBoarding.substep == 14">
        <a class="text-primary mt-5" type="button" @click="showModal(15)"><i class="icon-arrow-right"></i>
          {{
            $t(
              "lang.onBoarding.see_email_examples_generated",
              this.$store.state.onboarding.lang
            )
          }}
        </a>
      </div>

      <!-- MODAL Select Client, only to Admin -->
      <Modal :name="'selectClient'" :size="'40'"
        v-if="!loading && onBoarding.startProcess && hasPermissions('adminClients')" :close="false"
        v-bind:close-on-backdrop="false" v-bind:close-on-esc="false" :max-width="800">
        <div class="p-4 mt-5 text-center">
          <h4 class="d-inline">
            {{
              $t(
                "lang.orders.choose_client",
                this.$store.state.onboarding.lang
              )
            }}
          </h4>
          <i class="ml-2 text-danger">*</i>
        </div>

        <!-- Select client and user -->
        <div class="d-flex flex-column align-items-center justify-content-center mb-5 mt-4">
          <div class="col-md-8 flex-row mb-4 d-flex justify-content-start align-items-end">
            <label>Client</label>
            <multiselect v-model="clientSelected" label="name" track-by="id" :options="clients" :multiple="false"
              :taggable="false" :searchable="true" :showLabels="false" openDirection="below" class="medium"
              @input="getUserByClient">
            </multiselect>
          </div>
          <div class="col-md-8 flex-row justify-content-start align-items-end">
            <label>User Billing</label>
            <treeselect v-model="userBillingSelected" class="mb-2" :multiple="false" :required="true" :maxHeight="200"
              :show-count="true" :searchable="true" :append-to-body="true" :options="billingUsers"
              :disabled="!clientSelected || loadingUsers" @input="setUserId(userBillingSelected)">
            </treeselect>
          </div>
        </div>

        <!-- Buttons Back and Next -->
        <div class="row justify-content-center mt-4 mb-5">
          <button class="btn cursor-pointer btn-sm btn-custom-color mx-1 px-3" @click="goBack()">
            {{ $t("lang.button.back") }}
          </button>
          <button class="btn cursor-pointer btn-sm btn-primary mx-1 px-3 ml-5" @click="nextSubStep('language')"
            :disabled="(!clientSelected && !userBillingSelected) || loadingUsers">
            {{ $t("lang.button.next") }}
          </button>
        </div>
      </Modal>

      <!-- MODAL Name and Language -->
      <Modal :name="'language'" :size="'40'" v-if="!loading && onBoarding.startProcess" :close="false"
        v-bind:close-on-backdrop="false" v-bind:close-on-esc="false" :max-width="800">
        <div class="p-4 mt-5 text-center">
          <h4 class="d-inline">
            {{
              $t(
                "lang.onBoarding.step1_0_modal_title",
                this.$store.state.onboarding.lang
              )
            }}
          </h4>
          <i class="ml-2 text-danger">*</i>
          <div class="row justify-content-center mt-5 mx-0">
            <div class="col-10">
              <input class="w-100 d-inline  text-center text-primary  mb-1 lead pl-2 border-style-dashed" type="text"
                maxlength="150" :placeholder="$t(
                      'lang.orders.example_name',
                      this.$store.state.onboarding.lang
                    )
                    " :value="onBoarding.orderName" @input="changeOrderName" />
              <span class="col-12 text-center mt-2">
                {{
                  $t(
                    "lang.label.charactersavailable",
                    this.$store.state.onboarding.lang,
                    { actual: onBoarding.orderName.length, total: 150 }
                  )
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- Select Language -->
        <div class="row justify-content-center mb-5 mt-4">
          <div class="col-md-6 d-flex justify-content-center align-items-end">
            <label for="staticEmail" class="font-weight-bold mr-3">{{ $t("lang.label.language") }}:
            </label>

            <button type="button" @click="showFlag = true" class="btn btn-light  px-4 py-0 my-0 mx-0"
              style="background-color:white; border:1px solid gray" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <span class="d-flex justify-content-center px-1 py-1"
                style="background-color:white; border:1px solid white">
                <span>{{ getLangSelected }}
                  <img width="25" :src="flagActually(null)" class="flag ml-4" />
                </span>
              </span>
            </button>

            <div class="dropdown-menu dropdown-menu-left">
              <button v-for="(lang, i) of langs" class="dropdown-item" type="button" :key="i" @click="changeLanguage(i)">
                <div class="row">
                  <div class="col-8">
                    <span class="ml-0 small">{{ lang.label }}</span>
                  </div>
                  <div class="col-4">
                    <img :src="flagActually(lang.type)" class="flag2 mr-3" width="25" />
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <!-- Buttons Back and Next -->
        <div class="row justify-content-center mt-4 mb-5">
          <button class="btn cursor-pointer btn-sm btn-custom-color mx-1 px-3" @click="goBack('selectClient')">
            {{ $t("lang.button.back") }}
          </button>
          <button class="btn cursor-pointer btn-sm btn-primary mx-1 px-3 ml-5" @click="nextSubStep(null)"
            :disabled="answerNull()">
            {{ $t("lang.button.next") }}
          </button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import MailsModal from "@/components/Onboarding/MailsModal.vue";
import Modal from "@/components/Common/Modal.vue";
import Tips from "@/components/Common/Tips.vue";
import Example from "@/components/Common/Example.vue";
import Step1Summary from "@/components/Onboarding/MultiSteps/Step1Summary.vue";
import SubstepTextCard from "@/components/Onboarding/MultiSteps/SubstepTextCard.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { mapState, mapActions } from "vuex";
import { monitorService, usersService } from "@/_services";

export default {
  computed: {
    ...mapState({
      onBoarding: state => state.onboarding,
      loading: state => state.onboarding.loading,
      user: state => state.authentication.user,
      subStep: state => state.onboarding.substep,
      tag_2: state => state.optionsList.all["tag_2"].data
    }),
    getLangSelected() {
      let lang = null;
      if (this.onBoarding.lang != "") {
        lang = this.langs.find(e => e.type == this.onBoarding.lang).label;
      } else {
        lang = this.langs.find(e => e.type == "fr").label;
      }

      return lang;
    },
    flagActually() {
      return id => {
        if (id) {
          const flag = this.flags.find(e => e.id === id).text;
          return require("@/assets/images/flags/" + flag);
        } else {
          if (this.onBoarding.lang != "") {
            const flag = this.flags.find(e => e.id === this.onBoarding.lang)
              .text;
            return require("@/assets/images/flags/" + flag);
          } else {
            return require("@/assets/images/flags/fr.svg");
          }
        }
      };
    },
    characterResponseCounter() {
      return (question, answer, total) => {
        return `${this.$t("lang.label.charactersavailable", {
          actual: this.onBoarding.questions.data.find(
            e => e.question === question
          ).answers[answer - 1].text.length,
          total
        })}`;
      };
    },
    getVideo() {
      // Verificar si el evento ya se ha cargado
      if (!window.dataLayer || !window.dataLayer.some(item => item.event === 'Page_Demonstration_Ouverte')) {
        // Si el evento no está presente, cargarlo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Page_Demonstration_Ouverte',
        });
      }
      return this.videoList.find(e => e.lang === this.user.lang_code) === undefined ? this.videoList.find(e => e.lang === 'en').url : this.videoList.find(e => e.lang === this.user.lang_code).url
    }
  },
  props: {
    addOrder: Boolean
  },
  data() {
    return {
      billingUsers: [
        {
          id: 0,
          label: 'Select user...'
        },
      ],
      userBillingSelected: 0,
      clientSelected: 0,
      loadingUsers: false,
      clients: [
        {
          id: 0,
          label: 'Select client...'
        },
      ],
      videoList: [
        { lang: "fr", url: "https://www.videoask.com/fpydkhwcl" },
        { lang: "en", url: "https://www.videoask.com/fmd8uhfra" },
        { lang: "es", url: "https://www.videoask.com/f7ay6wy4l" },
      ],
      showMessages: [],
      select_offer_prospect: [
        {
          id: 1,
          label: this.$t(
            "lang.onBoarding.offer_1",
            this.$store.state.onboarding.lang
          )
        },
        {
          id: 2,
          label: this.$t(
            "lang.onBoarding.offer_2",
            this.$store.state.onboarding.lang
          )
        },
        {
          id: 3,
          label: this.$t(
            "lang.onBoarding.offer_3",
            this.$store.state.onboarding.lang
          )
        },
        {
          id: 4,
          label: this.$t(
            "lang.onBoarding.offer_4",
            this.$store.state.onboarding.lang
          )
        }
      ],
      flags: [
        { id: "fr", text: "fr.svg" },
        { id: "en", text: "us.svg" },
        { id: "es", text: "es.svg" },
        { id: "it", text: "it.svg" },
        { id: "pt", text: "pt.svg" },
      ],
      substepsdata: [],
      loadingCreditCard: false,
      langs: [
        {
          id: 1,
          type: "fr",
          label: this.$t("lang.onBoarding.lang.french")
        },
        {
          id: 2,
          type: "en",
          label: this.$t("lang.onBoarding.lang.english")
        },
        {
          id: 3,
          type: "es",
          label: this.$t("lang.onBoarding.lang.spanish")
        },
        {
          id: 4,
          type: "it",
          label: this.$t("lang.onBoarding.lang.italian")
        },
        {
          id: 5,
          type: "pt",
          label: this.$t("lang.onBoarding.lang.portuguese")
        }
      ]
    };
  },

  components: {
    MailsModal,
    Step1Summary,
    SubstepTextCard,
    VideoToolToy,
    CreditCardForm,
    Modal,
    Tips,
    Example,
    IndustrySearch,
    treeselect: Treeselect,
  },
  mounted() {
    if (!this.onBoarding.orderId) {
      this.setClientId(0);
      this.setUserId(null);
    }
    this.getClients();
    // If  productName is empty then register company_name in onboarding as productName
    if (!this.onBoarding.productName && this.user.client_name) {
      this.updateProductName(this.user.client_name)
    }

    // If  website is empty then register website in onboarding prop
    if (!this.onBoarding.website && this.user.client_website) {
      this.updateWebsite(this.user.client_website)
    }

    if (!this.onBoarding.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.$store.dispatch("optionsList/getAvailableTokens");

    this.substepsdata = [
      {
        substep: 4,
        key: 7,
        value: "what_we_created",
        value2: undefined,
        value3: undefined,
        tip: true,
        index: 1,
        type: 1
      },
      {
        substep: 5,
        value: "we_propose",
        value2: undefined,
        value3: undefined,
        index: 2,
        type: 1,
        key: 1
      },
      {
        substep: 6,
        key: 2,
        value: "we_are_convinced",
        value2: undefined,
        value3: undefined,
        subStep: 4,
        index: 3,
        type: 2
      },
      {
        substep: 7,
        key: 3,
        value: "in_few_words",
        value2: undefined,
        value3: undefined,
        index: 4,
        type: 2
      },
      {
        substep: 8,
        key: 4,
        value: "we_wanted_to_exchange_about",
        value2: undefined,
        value3: undefined,
        index: 5,
        type: 2
      },
      {
        substep: 9,
        key: 5,
        value: "the_idea_is_simple",
        value2: undefined,
        value3: undefined,
        index: 6,
        type: 2
      },
      {
        substep: 10,
        key: 6,
        value: "we_were_wondering_how",
        value2: undefined,
        value3: undefined,
        index: 7,
        type: 2
      },
      {
        substep: 11,
        value: "prospect_area",
        value2: undefined,
        value3: undefined,
        index: 8,
        type: 3,
        key: 8
      },
      {
        substep: 12,
        key: 9,
        value: "argument_1",
        value2: "argument_2",
        value3: "argument_3",
        index: 9,
        type: 5
      },
      {
        substep: 13,
        key: 10,
        value: "ref_1",
        value2: "ref_2",
        value3: "ref_3",
        index: 10,
        type: 4
      }
    ];

    if (this.onBoarding.substep == 1 && this.onBoarding.step == 1) {
      if (this.hasPermissions('adminClients')) {
        this.$modal.show("selectClient");
      } else {
        this.$modal.show("language");
      }

    }

    if (
      this.onBoarding.substep == 0 &&
      this.onBoarding.step == 1 &&
      this.onBoarding.orderId == 0 &&
      this.user.agency_signed == "0" &&
      !this.addOrder &&
      !this.simplify
    ) {
      this.$modal.show("confirm");
    }

    this.substepsdata = [
      {
        substep: 4,
        key: 7,
        value: "what_we_created",
        value2: undefined,
        value3: undefined,
        tip: true,
        index: 1,
        type: 1
      },
      {
        substep: 5,
        value: "we_propose",
        value2: undefined,
        value3: undefined,
        index: 2,
        type: 1,
        key: 1
      },
      {
        substep: 6,
        key: 2,
        value: "we_are_convinced",
        value2: undefined,
        value3: undefined,
        subStep: 4,
        index: 3,
        type: 2
      },
      {
        substep: 7,
        key: 3,
        value: "in_few_words",
        value2: undefined,
        value3: undefined,
        index: 4,
        type: 2
      },
      {
        substep: 8,
        key: 4,
        value: "we_wanted_to_exchange_about",
        value2: undefined,
        value3: undefined,
        index: 5,
        type: 2
      },
      {
        substep: 9,
        key: 5,
        value: "the_idea_is_simple",
        value2: undefined,
        value3: undefined,
        index: 6,
        type: 2
      },
      {
        substep: 10,
        key: 6,
        value: "we_were_wondering_how",
        value2: undefined,
        value3: undefined,
        index: 7,
        type: 2
      },
      {
        substep: 11,
        value: "prospect_area",
        value2: undefined,
        value3: undefined,
        index: 8,
        type: 3,
        key: 8
      },
      {
        substep: 12,
        key: 9,
        value: "argument_1",
        value2: "argument_2",
        value3: "argument_3",
        index: 9,
        type: 5
      },
      {
        substep: 13,
        key: 10,
        value: "ref_1",
        value2: "ref_2",
        value3: "ref_3",
        index: 10,
        type: 4
      }
    ];
    this.validateSubStep();
    this.changeLanguage();
  },
  watch: {
    subStep() {
      this.validateSubStep();
    }
  },
  methods: {
    ...mapActions("onboarding", {
      setClientId: "setClientId",
      setUserId: "setUserId",
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getUserByClient(selectFirstUser = true) {
      this.setClientId(this.clientSelected.id)
      this.loadingUsers = true
      monitorService.getMonitorList(this.clientSelected.id).then(result => {
        const users = result
          .filter(e => e.role_id === "4")
          .map(el => ({ id: el.id, label: el.lastname + ', ' + el.name }))
        this.billingUsers = users;
        if (users.length > 0) {
          this.userBillingSelected = users[0].id;
          if (selectFirstUser) this.setUserId(users[0].id);
        }
        this.loadingUsers = false
      });
    },
    getClients() {
      const toCreateUser = 1;
      monitorService.getClients(null, "2,3,4,5,9", toCreateUser)
        .then(res => {
          this.clients = res //.filter( (el, index) => index < 800);
        })
        .catch(err => console.log(err));
    },
    showInputMessage(question, answer) {
      const answerFound = this.showMessages.find(
        e => e.question === question && e.answer === answer
      );
      if (answerFound) {
        if (answerFound.status === "enable") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showMessage(question, status, answer) {
      const findAnswer = this.showMessages.findIndex(
        e => e.question === question && e.answer === answer
      );
      if (findAnswer >= 0) {
        this.showMessages.find(
          e => e.question === question && e.answer === answer
        ).status = status;
      } else {
        this.showMessages.push({
          question: question,
          answer: answer,
          status: status
        });
      }
    },
    refreshPaymentMethods() {
      location.reload();
    },
    start() {

      this.setSubStep(1);
      this.setStep(1);
      this.$modal.show("language");
    },
    goBack(go = null) {
      if (this.addOrder) {
        if (this.hasPermissions('adminClients') && (go === 'selectClient')) {
          if (!this.onBoarding.orderId) {
            this.$modal.hide("language");
            this.$modal.show("selectClient");
          } else {
            // const clientId = this.onBoarding.orderdata.client_id;
            // const usertId = this.onBoarding.orderdata.client_id;

            // this.setClientId(clientId)
            // this.setUserId(usertId)
          }
        } else {
          this.$router.push("/orders");
        }
      } else {
        this.back();
      }
    },
    validateSubStep() {
      if (this.onBoarding.substep == 1 && this.onBoarding.step == 1) {

        if (this.hasPermissions('adminClients')) {
          if (!this.onBoarding.client_id) {
            this.$modal.show("selectClient");
          } else {
            this.$modal.show("language");
          }
        } else {
          this.$modal.show("language");
        }
        // this.$modal.show("language");
      }

      if (this.onBoarding.substep == 0 && this.onBoarding.step == 1) {
        if (this.hasPermissions('adminClients')) {
          if (this.onBoarding.orderId) {
            const clientId = this.onBoarding.orderdata.client_id;
            const usertId = this.onBoarding.orderdata.client_id;

            this.setClientId(clientId)
            this.setUserId(usertId)
            this.clientSelected.id = clientId;

            this.getUserByClient(false);
            this.userBillingSelected = usertId;

            this.$nextTick(function () {
              this.$modal.show("language");
            });

          } else {
            if (!this.onBoarding.client_id) {
              this.$modal.show("selectClient");
            } else {
              this.$modal.show("language");
            }
          }
        }
      }
    },
    summary() {
      let subStep = this.onBoarding.substep + 1;
      this.setSubStep(subStep);
    },
    nextSubStep(next = null) {
      if (next === 'language') {
        this.$modal.hide("selectClient");
        this.$modal.show("language");
      } else {
        this.$modal.hide("language");
        this.setSubStep(1);
      }
    },
    answerNull(substep) {
      return !this.onBoarding.orderName;
    },
    isBdrUser() {
      if(this.user && this.user.team_role_id == 2 && this.user.role_id == 2){
        return true
      } else {
        return false
      }
    },
    changeLanguage(index = null) {
      if (index == null && this.onBoarding.language_id === 0) {
        if(this.isBdrUser) {
           this.setLanguageId(1);
        } else {
          this.setLanguageId(this.user.language_id);
        }
        
        return false;
      }
      if (index != null) {

        const language_id = this.langs.find((e, i) => i === index).id;
        this.onBoarding.lang = this.langs.find((e, i) => i === index).type;

        this.setLanguageId(language_id);
      }
    },

    showModal(subStep) {
      this.$modal.show("step" + subStep);
    },
    closeModal(step) {
      this.$modal.hide("step" + step);
      this.request = false;
    },
    
    ...mapActions("onboarding", {
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      updateOrderName: "updateOrderName",
      updateProductName: "updateProductName",
      updateDescriptionSell: "updateDescriptionSell",
      updateBenefitsOffer: "updateBenefitsOffer",
      updateWebsite: "updateWebsite",
      updateQuestions: "updateQuestions",
      updateTagId: "updateTagId",
      updateOfferProspect: "updateOfferProspect",
      setLanguageId: "setLanguageId",
      saveOrder: "save",
      back: "back",
      next: "next"
    }),

    changeOrderName(e) {
      this.updateOrderName(e.target.value);
    },
    changeProductName(e) {
      this.updateProductName(e.target.value);
    },
    changeWebsite(e) {
      this.updateWebsite(e.target.value);
    },
    changeOfferBenefits(e) {
      this.updateBenefitsOffer(e.target.value);
    },
    changeDescriptionSell(e) {
      this.updateDescriptionSell(e.target.value);
    },
    changeQuestions(e, question = null, answer = null) {
      const data = {
        input: e.target.value,
        question: question,
        answer: answer
      };
      this.updateQuestions(data);
    },
    changeTagId(e) {
      this.updateTagId(e.target.value);
    },
    changeOfferProspect(e) {
      this.updateOfferProspect(e.target.value);
    }
  }
};
</script>
<style scoped>
.text-size-20 {
  font-size: 20px;
}

.langSelect {
  border: 0.1px lightgray solid;
  background: transparent;
  outline: 0px;
}

.btn-custom-color {
  background: rgba(110, 110, 110, 0.19);
}

.border-style-dashed {
  border-style: dashed;
  border-bottom: 1px dashed;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}
</style>
